import React from 'react';
import { useParams } from 'react-router-dom';
import { XIcon } from '@phosphor-icons/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUsers } from 'api/users';
import { createPermission } from 'api/permissions';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';

export default function OfficeAddUserPopup({
    visible,
    setVisible,
    presentUsers
}) {

    const { officeId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['createPermission'],
        mutationFn: createPermission,
        onSuccess: () => {
            cache.invalidateQueries(['permissions']);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error creating permission:", error);
        }
    });

    const { data: users } = useQuery({
        queryKey: ['users'],
        queryFn: async () => await getUsers({}),
    });


    const usersOptions = users?.map(user => {
        return {
            value: user._id,
            label: `${user.firstname} ${user.lastname}`
        }
    });


    function onSubmitHandler(e) {
        e.preventDefault();
        
        return update({
            data: { 
                element: officeId,
                elementType: 'offices',
                user: e.target.user.value,
                auth: e.target.auth.value
            }
        });
    }

    return (
        <div className={`fixed top-0 left-0 w-full h-full bg-white/90 bg-opacity-50 z-[var(--z-modal)] transition-all duration-300 ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
            <div className='bg-white rounded-sm border border-greylight w-full max-w-lg mx-4 md:mx-auto mt-40'>
                <div className='flex justify-between items-center p-6 border-b border-greylight'>
                    <p className='text-black text-lg font-medium'>{`Aggiungi ufficio all'area`}</p>
                    <div onClick={() => setVisible(false)} className='cursor-pointer text-black hover:text-black'>
                        <XIcon size={20} />
                    </div>
                </div>

                <div className='p-6'>
                    <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                        {usersOptions &&
                            <SelectInput
                                label="Utente"
                                name="user"
                                options={usersOptions?.filter(user => !presentUsers?.includes(user.value))}
                                required
                            />
                        }
                        <SelectInput
                            label="Permessi"
                            name="auth"
                            options={[
                                { value: 'admin', label: 'Amministratore' },
                                { value: 'read', label: 'Lettura' },
                                { value: 'write', label: 'Lettura e Scrittura' }
                            ]}
                            required
                        />

                        <div className='flex justify-between gap-4 mt-6'>
                            <div onClick={() => setVisible(false)} className='text-muted hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                                Annulla
                            </div>
                            <Button submit>Conferma</Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
